(() => {
  const header = document.querySelector("[data-header]");
  const megaLayer = document.querySelector("[data-mega-layer]");
  const triggers = Array.from(document.querySelectorAll("[data-mega-target]"));
  const panels = Array.from(document.querySelectorAll("[data-mega-panel]"));

  function closeMega() {
    if (!megaLayer) return;
    megaLayer.hidden = true;
    triggers.forEach((trigger) => trigger.setAttribute("aria-expanded", "false"));
    panels.forEach((panel) => panel.classList.remove("is-active"));
  }

  function openMega(name, trigger) {
    if (!megaLayer) return;
    if (header) {
      megaLayer.style.top = `${Math.round(header.getBoundingClientRect().bottom)}px`;
    }
    megaLayer.hidden = false;
    triggers.forEach((item) => item.setAttribute("aria-expanded", item === trigger ? "true" : "false"));
    panels.forEach((panel) => {
      panel.classList.toggle("is-active", panel.dataset.megaPanel === name);
    });
  }

  triggers.forEach((trigger) => {
    trigger.setAttribute("aria-expanded", "false");
    trigger.addEventListener("click", () => {
      const target = trigger.dataset.megaTarget;
      const activePanel = panels.find((panel) => panel.dataset.megaPanel === target);
      const isOpen = activePanel && activePanel.classList.contains("is-active") && !megaLayer.hidden;
      if (isOpen) {
        closeMega();
      } else {
        openMega(target, trigger);
      }
    });
  });

  // Open mega menus on hover (desktop pointers)
  const canHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  if (canHover && megaLayer) {
    let closeTimer = null;
    const cancelClose = () => { if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } };
    const scheduleClose = () => { cancelClose(); closeTimer = setTimeout(closeMega, 200); };
    triggers.forEach((trigger) => {
      trigger.addEventListener("mouseenter", () => { cancelClose(); openMega(trigger.dataset.megaTarget, trigger); });
      trigger.addEventListener("mouseleave", scheduleClose);
    });
    megaLayer.addEventListener("mouseenter", cancelClose);
    megaLayer.addEventListener("mouseleave", scheduleClose);
  }

  document.addEventListener("click", (event) => {
    if (!header || header.contains(event.target)) return;
    closeMega();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeMega();
  });

  window.addEventListener("scroll", () => {
    if (megaLayer && !megaLayer.hidden && header) {
      megaLayer.style.top = `${Math.round(header.getBoundingClientRect().bottom)}px`;
    }
  }, { passive: true });

  const searchForm = document.querySelector("[data-search-form]");
  if (searchForm) {
    const categorySelect = searchForm.querySelector("[data-search-category]");
    searchForm.addEventListener("submit", (event) => {
      if (!categorySelect || !categorySelect.value) return;
      const query = searchForm.querySelector("input[name='q']");
      if (!query || query.value.trim() === "") {
        event.preventDefault();
        window.location.href = categorySelect.value;
      }
    });
  }

  const revealGroups = Array.from(document.querySelectorAll("[data-reveal-group]"));
  if (revealGroups.length && "IntersectionObserver" in window) {
    const revealObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -12% 0px" }
    );
    revealGroups.forEach((group) => revealObserver.observe(group));
  } else {
    revealGroups.forEach((group) => group.classList.add("is-revealed"));
  }

  const navToggle = document.querySelector("[data-nav-toggle]");
  const mobileNav = document.querySelector("[data-mobile-nav]");
  if (navToggle && mobileNav) {
    const setNav = (open) => {
      if (open) mobileNav.removeAttribute("hidden");
      else mobileNav.setAttribute("hidden", "");
      navToggle.setAttribute("aria-expanded", String(open));
      navToggle.classList.toggle("is-open", open);
    };
    navToggle.addEventListener("click", (event) => {
      event.stopPropagation();
      setNav(mobileNav.hasAttribute("hidden"));
    });
    document.addEventListener("click", (event) => {
      if (mobileNav.hasAttribute("hidden")) return;
      if (mobileNav.contains(event.target) || navToggle.contains(event.target)) return;
      setNav(false);
    });
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") setNav(false);
    });
  }

  const searchToggle = document.querySelector("[data-search-toggle]");
  const headerEl = document.querySelector(".site-header");
  if (searchToggle && headerEl) {
    const searchInput = headerEl.querySelector(".search-box input[type='search']");
    searchToggle.addEventListener("click", (event) => {
      event.stopPropagation();
      const open = !headerEl.classList.contains("search-open");
      headerEl.classList.toggle("search-open", open);
      searchToggle.classList.toggle("is-open", open);
      searchToggle.setAttribute("aria-expanded", String(open));
      if (open && searchInput) {
        setTimeout(() => searchInput.focus(), 30);
      }
    });
  }

  const themeToggle = document.querySelector("[data-theme-toggle]");
  if (themeToggle) {
    const root = document.documentElement;
    const sync = () => themeToggle.setAttribute("aria-pressed", String(root.getAttribute("data-theme") === "dark"));
    sync();
    themeToggle.addEventListener("click", () => {
      const next = root.getAttribute("data-theme") === "dark" ? "light" : "dark";
      if (next === "dark") root.setAttribute("data-theme", "dark");
      else root.removeAttribute("data-theme");
      try { localStorage.setItem("kb-theme", next); } catch (e) {}
      sync();
    });
  }

})();

// Quantity steppers (product page + cart page). On the cart page the form
// re-submits a moment after the last click so totals and the shipping bar refresh.
(() => {
  const sync = (wrap) => {
    const input = wrap.querySelector('input');
    const minus = wrap.querySelector('[data-qty-step="-1"]');
    const min = parseInt(input.min || '0', 10);
    if (minus) minus.disabled = (parseInt(input.value, 10) || 0) <= min;
  };
  document.querySelectorAll('[data-qty-stepper]').forEach(sync);

  const timers = new WeakMap();
  const autosubmit = (wrap) => {
    if (!wrap.hasAttribute('data-qty-autosubmit')) return;
    const form = wrap.closest('form');
    if (!form) return;
    clearTimeout(timers.get(form));
    timers.set(form, setTimeout(() => {
      const btn = form.querySelector('button[name="update"]');
      form.classList.add('is-updating');
      btn ? form.requestSubmit(btn) : form.submit();
    }, 650));
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    const wrap = btn.closest('[data-qty-stepper]');
    const input = wrap && wrap.querySelector('input');
    if (!input) return;
    const min = parseInt(input.min || '0', 10);
    const next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.qtyStep, 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    sync(wrap);
    autosubmit(wrap);
  });

  document.addEventListener('change', (e) => {
    const wrap = e.target.closest && e.target.closest('[data-qty-stepper]');
    if (!wrap || e.target.tagName !== 'INPUT') return;
    sync(wrap);
  });
})();
